export default __webpack_public_path__ + "static/media/close.fea5b3fa.svg";